export const formSubmissionSuccessDelay = 1500;
export const formErrorsDisplayDelay = 300;
export const formErrorsDisplayDelayAfterResponse = 200;
export const formDropdownErrorDisplayDelay = 20;
